import { faFile } from "@fortawesome/pro-solid-svg-icons";

import { CircularIcon } from "@aviary/components/CircularIcon";

const AttachmentFileIcon = () => {
  return (
    <div>
      <CircularIcon icon={faFile} size="xsmall" isColor="success" />
    </div>
  );
};

export { AttachmentFileIcon };
